function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { isFieldDef } from '../../channeldef';
import { pathGroupingFields } from '../../encoding';
import { isImputeSequence } from '../../transform';
import { duplicate, hash as _hash } from '../../util';
import { DataFlowNode } from './dataflow';
export var ImputeNode = /*#__PURE__*/function (_DataFlowNode) {
  function ImputeNode(parent, transform) {
    var _this;
    _classCallCheck(this, ImputeNode);
    _this = _callSuper(this, ImputeNode, [parent]);
    _this.transform = transform;
    return _this;
  }
  _inherits(ImputeNode, _DataFlowNode);
  return _createClass(ImputeNode, [{
    key: "clone",
    value: function clone() {
      return new ImputeNode(null, duplicate(this.transform));
    }
  }, {
    key: "dependentFields",
    value: function dependentFields() {
      var _this$transform$group;
      return new Set([this.transform.impute, this.transform.key].concat(_toConsumableArray((_this$transform$group = this.transform.groupby) !== null && _this$transform$group !== void 0 ? _this$transform$group : [])));
    }
  }, {
    key: "producedFields",
    value: function producedFields() {
      return new Set([this.transform.impute]);
    }
  }, {
    key: "processSequence",
    value: function processSequence(keyvals) {
      var _keyvals$start = keyvals.start,
        start = _keyvals$start === void 0 ? 0 : _keyvals$start,
        stop = keyvals.stop,
        step = keyvals.step;
      var result = [start, stop].concat(_toConsumableArray(step ? [step] : [])).join(',');
      return {
        signal: "sequence(".concat(result, ")")
      };
    }
  }, {
    key: "hash",
    value: function hash() {
      return "Impute ".concat(_hash(this.transform));
    }
  }, {
    key: "assemble",
    value: function assemble() {
      var _this$transform = this.transform,
        impute = _this$transform.impute,
        key = _this$transform.key,
        keyvals = _this$transform.keyvals,
        method = _this$transform.method,
        groupby = _this$transform.groupby,
        value = _this$transform.value,
        _this$transform$frame = _this$transform.frame,
        frame = _this$transform$frame === void 0 ? [null, null] : _this$transform$frame;
      var imputeTransform = _objectSpread(_objectSpread(_objectSpread({
        type: 'impute',
        field: impute,
        key: key
      }, keyvals ? {
        keyvals: isImputeSequence(keyvals) ? this.processSequence(keyvals) : keyvals
      } : {}), {}, {
        method: 'value'
      }, groupby ? {
        groupby: groupby
      } : {}), {}, {
        value: !method || method === 'value' ? value : null
      });
      if (method && method !== 'value') {
        var deriveNewField = _objectSpread({
          type: 'window',
          as: ["imputed_".concat(impute, "_value")],
          ops: [method],
          fields: [impute],
          frame: frame,
          ignorePeers: false
        }, groupby ? {
          groupby: groupby
        } : {});
        var replaceOriginal = {
          type: 'formula',
          expr: "datum.".concat(impute, " === null ? datum.imputed_").concat(impute, "_value : datum.").concat(impute),
          as: impute
        };
        return [imputeTransform, deriveNewField, replaceOriginal];
      } else {
        return [imputeTransform];
      }
    }
  }], [{
    key: "makeFromTransform",
    value: function makeFromTransform(parent, imputeTransform) {
      return new ImputeNode(parent, imputeTransform);
    }
  }, {
    key: "makeFromEncoding",
    value: function makeFromEncoding(parent, model) {
      var encoding = model.encoding;
      var xDef = encoding.x;
      var yDef = encoding.y;
      if (isFieldDef(xDef) && isFieldDef(yDef)) {
        var imputedChannel = xDef.impute ? xDef : yDef.impute ? yDef : undefined;
        if (imputedChannel === undefined) {
          return undefined;
        }
        var keyChannel = xDef.impute ? yDef : yDef.impute ? xDef : undefined;
        var _imputedChannel$imput = imputedChannel.impute,
          method = _imputedChannel$imput.method,
          value = _imputedChannel$imput.value,
          frame = _imputedChannel$imput.frame,
          keyvals = _imputedChannel$imput.keyvals;
        var groupbyFields = pathGroupingFields(model.mark, encoding);
        return new ImputeNode(parent, _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
          impute: imputedChannel.field,
          key: keyChannel.field
        }, method ? {
          method: method
        } : {}), value !== undefined ? {
          value: value
        } : {}), frame ? {
          frame: frame
        } : {}), keyvals !== undefined ? {
          keyvals: keyvals
        } : {}), groupbyFields.length ? {
          groupby: groupbyFields
        } : {}));
      }
      return null;
    }
  }]);
}(DataFlowNode);